import BaseListItem from '@components/common/atoms/BaseListItem';
import BaseContainer from '@components/common/atoms/container/BaseContainer';
import { useRootStore } from '@hooks/useRootStore';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import LogoutTwoToneIcon from '@mui/icons-material/LogoutTwoTone';
import PasswordTwoToneIcon from '@mui/icons-material/PasswordTwoTone';
import { Divider, List, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface UserAccountPageProps {
}

const UserAccountPage: React.FC<UserAccountPageProps> = ({ }) => {
    const navigate = useNavigate();
    const { authorizationStore, authenticationStore } = useRootStore();
    const { user } = authorizationStore;
    const { logoutAsync } = authenticationStore;
    return (
        <BaseContainer maxWidth='md' usePaperWrapper>
            <Typography ml={1} variant="h5">{`Hej, ${user?.firstName}`}</Typography>
            <Typography ml={1} mb={2}>Uredi svoj profil, promijeni lozinku...</Typography>
            <List>
                <BaseListItem
                    title='Uredi profil'
                    description='uredi svoje osobne podatke'
                    icon={<AccountCircleTwoToneIcon />}
                    onClick={() => navigate(`/user-settings/${user?.id}/edit`)} />
                <Divider variant="inset" component="li" />

                <BaseListItem
                    title='Promijeni lozinku'
                    description='promijeni lozinku za svoj naručko korisnički račun'
                    icon={<PasswordTwoToneIcon />}
                    onClick={() => navigate(`/user-settings/${user?.id}/password-change`)} />
                <Divider variant="inset" component="li" />

                <BaseListItem
                    title='Odjava'
                    description='uvijek se možeš ponovo prijaviti'
                    icon={<LogoutTwoToneIcon color='error' />}
                    onClick={logoutAsync} />
            </List>
        </BaseContainer>
    )
}

export default UserAccountPage;